import React from "react";

const Submit = ({handleFormSubmit, isProjectSaving, text}) => {
  return (
    <div className="row no-gutters d-flex justify-content-center">
      <div className="col-12 col-md-6">
        <button
          className="form-btn btn btn-lg btn-block btn-primary"
          disabled={isProjectSaving}
          onClick={handleFormSubmit}
          type="submit"
        >
          {text}
        </button>
      </div>
    </div>
  );
};

export default Submit;
